<template>
  <div>
    <ExecutionLogTable :orderCode="orderCode" />
  </div>
</template>
<script>
import ExecutionLogTable from './components/table'
export default {
  components: { ExecutionLogTable },
  props: { orderCode: { type: String, default: '' } },
}
</script>
